import './Footer.css'
export default function Footer(){
    return(
        <footer className="footer">
            <div className="footer-container">
                {/* Coluna 1: Sobre & Marca */}
                <div className="footer-col">
                <h3 className="footer-logo">LKSME <span>SERVIÇOS GERAIS</span></h3>
                <p className="footer-about">
                    Especialistas em estruturas metálicas e serralharia sob medida. Projetos residenciais, comerciais e industriais na Região Metropolitana de Belo Horizonte.
                </p>
                </div>

                {/* Coluna 2: Navegação Rápida */}
                <div className="footer-col">
                <h4>Navegação</h4>
                <ul className="footer-links">
                    <li><a href="#home">Início</a></li>
                    <li><a href="#sobre">Sobre Nós</a></li>
                    <li><a href="#portifolio">Portfólio</a></li>
                    <li><a href="#sobre">Contato</a></li>
                </ul>
                </div>

                {/* Coluna 3: Atendimento & Horários */}
                <div className="footer-col">
                <h4>Atendimento</h4>
                <p>📍 Belo Horizonte e Região</p>
                <p>📞 (31) 99618-8853</p>
                <p>✉️ sergiomontagemetalica@gmail.com</p>
                <p>⏰ Seg - Sex: 07h às 17h</p>
                </div>
            </div>

            {/* Linha de Copyright */}
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} LKSME Serviços Gerais. Todos os direitos reservados.</p>
            </div>
            </footer>
    )
} 